// Browser autofill or password managers can trigger fake keydown events that are missing keyboard information.
// Telerik doesn't handle those correctly and crashes. This listener catches and blocks those invalid events before
// they reach Telerik, while allowing normal keyboard events through.
document.addEventListener('keydown', (e) => {
    if (e.key !== undefined || e.keyCode !== undefined) return;

    const target = e.target;
    if (target && target.matches && target.matches('.k-input-inner')) {
        e.stopImmediatePropagation();
    }
}, true);
